enum OrganizationStripeProfileStatus {
  active = 'active',
  archived = 'archived',
}

export default OrganizationStripeProfileStatus
